<template>
  <main class="app-main">
    <div class="wrapper">
      <div class="page-inner">
        <breadcrumb title="Leave Request"></breadcrumb>
        <div class="card card-fluid">
          <div class="card-body">
            <div class="tab-content py-3" id="myTabContent">
              <div class="tab-pane fade" :class="{ 'active show': isActive('employee-status') }" id="home">
                <employee-status-detail></employee-status-detail>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import EmployeeStatusDetail from "@/components/pages/employee-status/EmployeeStatusDetail";

export default {
  name: "EmployeeStatusIndex",
  components:{
    EmployeeStatusDetail,
    Breadcrumb
  },
  data(){
    return {
      activeItem:"employee-status"
    }
  },
  methods:{
    setActive(itemTabs){
      this.activeItem = itemTabs
    },
    isActive(itemTabs){
      return this.activeItem === itemTabs
    },
  }
}
</script>